import { Highlight } from "client/Components";
import { normalizeForSearch } from "client/Data/searching";

export function getHighlight(
	text: string,
	searchTerm: string | undefined
): Highlight | undefined {
	if (!searchTerm) {
		return undefined;
	}

	const normalizedText: string = normalizeForSearch(text);
	const normalizedSearchTerm: string = normalizeForSearch(searchTerm);

	const startIndex: number = normalizedText.indexOf(normalizedSearchTerm);

	if (startIndex === -1) {
		return undefined;
	}

	return [startIndex, searchTerm.length];
}